import { render, staticRenderFns } from "./SidebarTabs.vue?vue&type=template&id=9b1098ca&scoped=true&"
import script from "./SidebarTabs.vue?vue&type=script&lang=js&"
export * from "./SidebarTabs.vue?vue&type=script&lang=js&"
import style0 from "./SidebarTabs.vue?vue&type=style&index=0&id=9b1098ca&prod&lang=css&"
import style1 from "./SidebarTabs.vue?vue&type=style&index=1&id=9b1098ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b1098ca",
  null
  
)

export default component.exports